import { isEmptyObject } from 'jquery';
import { Core as Uppy, Dashboard } from 'uppy';
import { RiskMatrixManager } from '../components/risk-matrix';
import { SelectOther } from "../_imports/select-with-other";
import { ReportField } from './report-field';
import { Utils } from '../utils';
import Swal from 'sweetalert2';
import { LedRiskMatrixManager } from '../components/led-risk-matrix';
import moment from 'moment';

declare const ATTACHMENTS: Record<string, any>;

export abstract class FieldType {
    public name: string;
    public has_other: boolean;
    public required: boolean;
    public multiple: boolean;
    public placeholder: string;
    public orientation: string;
    public default_value: string | null;
    public additional_options: any;
    public additional_validation_rules: any;
    public columns: any[];

    constructor(name: string, has_other: string, required: string, multiple: string, placeholder: string, orientation: string, default_value: string | null, additional_options: any, additional_validation_rules: string, columns: any[]) {
        this.name = name;
        this.has_other = has_other == '1';
        this.required = required == '1';
        this.multiple = multiple == '1';
        this.placeholder = placeholder;
        this.orientation = orientation;
        this.default_value = default_value;
        this.additional_options = additional_options;
        this.additional_validation_rules = additional_validation_rules;
        this.columns = columns;
    }

    public abstract initFormElement(container: JQuery<HTMLElement>|null): any;

    public initFilter(container: JQuery<HTMLElement>) {
        this.initFormElement(container);
    }

    public validate(container: JQuery<HTMLElement>): object {
        let validation = {};

        if(this.required) {
            validation = {
                required: true
            };
        }

        if(this.additional_validation_rules){
            const additional_validation_rules = JSON.parse(this.additional_validation_rules.validation_rules)
            for(const additional_validation_rule of additional_validation_rules){
                if(additional_validation_rule.rule_name === "at_least_one_compiled")
                    validation[additional_validation_rule.rule_name] = {field_names: additional_validation_rule.field_names.split(",")};
                else if(additional_validation_rule.rule_name === "unique_in_report"){
                    validation["remote"] = {
                        url: "ajax.validation.unique-in-report.php",
                        type: "POST",
                        data: {
                            field_id: this.additional_validation_rules.field_id,
                            version_id: additional_validation_rule.version_id,
                            submission_id: container.find("[name='id']").val(),
                            report_id: container.find("[name='type']").val(),
                            value: () => {
                                return container.find(`[name=${this.name}]`).val();
                            }
                        },
                        dataFilter: function (response) {
                            response = JSON.parse(response);
                            return !response.alreadyUsed;
                        }
                    };
                }
                else
                    validation[additional_validation_rule.rule_name] = {options: []};
            }
        }

        return {element_validation_rules: validation, other_element_validation_rules: null};
    }

    public validationMessages(): object {
        let messages = {};

        if(this.additional_validation_rules){
            const additional_validation_rules = JSON.parse(this.additional_validation_rules.validation_rules)
            for(const additional_validation_rule of additional_validation_rules){
                if(additional_validation_rule.rule_name === "unique_in_report"){
                    messages["remote"] = "This value is already used!";
                }
            }
        }

        return messages;
    }

    public prepare(formData: FormData, $form: JQuery<HTMLElement>|null = null) {
        return formData;
    }

    public serialize(container: JQuery<HTMLElement>) {
        return container.find(`[name=${this.name}]`).serialize();
    }

    protected formatOption(option) {
        const color = $(option.element).data("color");
        if (!color)
            return option.text;

        var $state = $(`
            <span>
                <span class="kt-badge kt-badge--${color} kt-badge--dot kt-badge--xl mr-2"></span> ${option.text}
            </span>
        `);

        return $state;
    }
}

export class Menu extends FieldType {

    public initFormElement(container: JQuery<HTMLElement>): any {

        let select2_options: any = {
            width: '100%',
            dropdownAutoWidth: true,
            placeholder: this.placeholder,
            templateResult: this.formatOption,
            templateSelection: this.formatOption
        };

        if(!this.additional_options || this.additional_options.has_search_box == 0) {
            select2_options.minimumResultsForSearch = -1;
        }

        let input_name = `[name=${this.name}]`;
        if(this.multiple)
            input_name = `[name="${this.name}[]"]`;
        
        let other_name = `[name=${this.name}_other]`;

        container.find(input_name).select2(select2_options).on("select2:close", function (e) {  
            container.find(input_name).valid(); 
        });

        if(this.has_other) {
            new SelectOther({
                select: container.find(input_name),
                showCallback: () => {
                    if(this.orientation === "horizontal")
                        container.find(input_name).closest('.select-container').removeClass("col-xl-12").addClass("col-xl-6");
                    container.find(other_name).closest('.other-container').removeClass("d-none");
                },
                hideCallback: () => {
                    if(this.orientation === "horizontal")
                        container.find(input_name).closest('.select-container').removeClass("col-xl-6").addClass("col-xl-12");
                    container.find(other_name).closest('.other-container').addClass("d-none");
                }
            });
        }

        container.find(input_name).closest(".form-group").find(".default-value-link").on("click", function (e) {
            const default_value = $(e.target).data("default-value");

            container.find(input_name).val(default_value);
            container.find(input_name).trigger("change");
        });
    }

    public validate(container: JQuery<HTMLElement>) {
        const validation = { element_validation_rules: super.validate(container)["element_validation_rules"] };
        let validation_other = {};

        if(this.has_other) {
            validation_other = {
                required: () => {
                    let input_name = `${this.name}`;
                    if(this.multiple){
                        input_name = `"${this.name}[]"`;

                        const value = container.find(`[name=${input_name}]`).val() as string;
                        return value.indexOf("other") !== -1;
                    }
                    else{
                        return container.find(`[name=${input_name}]`).val() === "other";
                    }
                }
            }
        }

        validation["other_element_validation_rules"] = (!isEmptyObject(validation_other)? validation_other : null);
        return validation;
    }
}

export class State extends FieldType {
    private states: Array<StateModel> = [];

    constructor(name: string, has_other: string, required: string, multiple: string, placeholder: string, orientation: string, default_value: string | null, additional_options: any, additional_validation_rules: string, columns: any[]) {

        super(name, has_other, required, multiple, placeholder, orientation, default_value, additional_options, additional_validation_rules, columns);

        this.states = JSON.parse($(`[name=${this.name}_json]`).val() as string);
    }

    public initFormElement(container: JQuery<HTMLElement>): any {
        let input_name = `[name=${this.name}]`;
        let world_region_input_name = `[name=${this.name}_world_region]`;
   
        container.find(input_name).select2({
            width: '100%',
            dropdownAutoWidth: true,
            minimumResultsForSearch: -1,
            placeholder: this.placeholder,
            templateResult: this.formatOption,
            templateSelection: this.formatOption
        }).on("select2:close", function (e) {  
            container.find(input_name).valid(); 
        });

        container.find(world_region_input_name).select2({
            width: '100%',
            dropdownAutoWidth: true,
            minimumResultsForSearch: -1,
            placeholder: this.placeholder,
            templateResult: this.formatOption,
            templateSelection: this.formatOption
        }).on("select2:close", function (e) {  
            container.find(world_region_input_name).valid(); 
        });

        // Disable the states select
        container.find(input_name).attr("disabled", "disabled");

        container.find(input_name).closest(".form-group").find(".default-value-link").on("click", function (e) {
            const default_value = $(e.target).data("default-value");

            container.find(input_name).val(default_value);
            container.find(input_name).trigger("change");
        });

        container.find(world_region_input_name).closest(".form-group").find(".default-value-link").on("click", function (e) {
            const default_value = $(e.target).data("default-value");

            container.find(world_region_input_name).val(default_value);
            container.find(world_region_input_name).trigger("change");
        });

        container.find(world_region_input_name).on("change", (e) => {

            let state_select_options = "";
            if (!this.required)
                state_select_options += "<option></option>";
            else if(this.required)
                state_select_options += `<option value="">${this.placeholder}</option>`

            if(!this.required)
                state_select_options += `<option value="not_applicable">[ N/A ]</option>`;

            const selected_world_region = $(world_region_input_name).val();

            for(const state of this.states){
                if(state.world_region_id == selected_world_region)
                    state_select_options += `<option value="${state.name}">${state.label}</option>`;
            }

            container.find(input_name).html(state_select_options);
            container.find(input_name).removeAttr("disabled");
        });

        // If a world region is already pre-selected (editing existing entry), trigger change
        // to populate and enable the state select, then restore the selected state value
        const preselected_world_region = container.find(world_region_input_name).val();
        if(preselected_world_region) {
            const preselected_state = container.find(input_name).val();
            container.find(world_region_input_name).trigger("change");
            if(preselected_state)
                container.find(input_name).val(preselected_state).trigger("change");
        }
    }

    public validate(container: JQuery<HTMLElement>) {
        const validation = { element_validation_rules: super.validate(container)["element_validation_rules"] };
        let validation_other = {};

        validation["other_element_validation_rules"] = (!isEmptyObject(validation_other)? validation_other : null);
        return validation;
    }

    public prepare(formData: FormData) {

        formData.delete(`${this.name}_world_region`);
        formData.delete(`${this.name}_json`);

        return formData;
    }
}

export class Email extends FieldType {

    public initFormElement(form: JQuery<HTMLElement>): any {
        let input_name = `[name=${this.name}]`;

        form.find(input_name).closest(".form-group").find(".default-value-link").on("click", function (e) {
            const default_value = $(e.target).data("default-value");

            form.find(input_name).val(default_value);
        });
    }

    public validate(container: JQuery<HTMLElement>) {
        const validation = super.validate(container);
    
        validation["element_validation_rules"]["email"] = true;

        return validation;
    }
}

export class Date extends FieldType {

    public initFormElement(container: JQuery<HTMLElement>): any {
        let input_name = `[name=${this.name}]`;

        const options: any = {
            todayHighlight: true,
            minView: 2,
            autoclose: true,
            format: 'dd/mm/yyyy',
            fontAwesome: true,
        };

        if(this.additional_options && this.additional_options.prevent_future_date == 1) {
            options.useCurrent = false;
            options.endDate = moment().toDate();
        }

        container.find(input_name).datetimepicker(options).on("changeDate", function (e) {  
            container.find(input_name).valid(); 
        });

        container.find(input_name).closest(".form-group").find(".default-value-link").on("click", function (e) {
            const default_value = $(e.target).data("default-value");

            container.find(input_name).val(default_value);
        });
    }
}

export class Time extends FieldType {

    public initFormElement(container: JQuery<HTMLElement>): any {
        let input_name = `[name=${this.name}]`;
        const $input = container.find(input_name);
        const savedValue = ($input.val() as string) || '';

        $input.val('');

        $input.datetimepicker({
            startView: 1,
			maxView: 1,
			autoclose: true,
			format: 'hh:ii',
			fontAwesome: true
        }).on("changeDate", function (e) {
            container.find(input_name).valid();
        });

        if (savedValue) {
            const parts = savedValue.split(':');
            if (parts.length === 2) {
                const d = moment().hour(parseInt(parts[0], 10)).minute(parseInt(parts[1], 10)).second(0).millisecond(0).toDate();
                ($input as any).datetimepicker('update', d);
            }
        }

        $input.closest(".form-group").find(".default-value-link").on("click", function (e) {
            const default_value = $(e.target).data("default-value");
            container.find(input_name).val(default_value);
        });
    }
}

export class File extends FieldType {
    file_input: any = null;

    public initFormElement(container: JQuery<HTMLElement>): any {
        if(container.length > 0){   //Se il form esiste
            let file_input = Uppy({
                id: `${this.name}`,
                autoProceed: false,
                restrictions: {
                    maxFileSize: 40 * 1024 * 1024
                }
            }).use(Dashboard, {
                target: `#${this.name}`,
                inline: true,
                height: 250,
                width: "100%",
                proudlyDisplayPoweredByUppy: false,
                hideUploadButton: true,
                hideRetryButton: true,
                hidePauseResumeButton: true,
                hideProgressAfterFinish: false
            });

            // Add existing attachments
            if(typeof ATTACHMENTS !== "undefined"){
                const selected = ATTACHMENTS.REVIEW.find(x => x.field == this.name);
                if(selected){
                    selected.attachments.forEach(async (file) => {
                        const blob = await fetch(file.src).then((response) => response.blob());
                        blob.name = file.title;
                        this.file_input.addFile({
                            meta: {
                                "id": file.id
                            },
                            name: file.title,
                            type: file.mimetype,
                            data: blob,
                            isRemote: true
                        });
                    });
                }
            }

            this.file_input = file_input;

            return file_input;
        }
    }

    public prepare(formData: FormData, $form?: JQuery<HTMLElement> | null): FormData {
        this.file_input.getFiles().forEach((file, i) => {
            formData.append(`${this.name}[]`, file.data, file.name);
        });
        return formData;
    }
}

export class Longtext extends FieldType {

    public initFormElement(form: JQuery<HTMLElement>): any {
        let input_name = `[name=${this.name}]`;

        form.find(input_name).closest(".form-group").find(".default-value-link").on("click", function (e) {
            const default_value = $(e.target).data("default-value");

            form.find(input_name).val(default_value);
        });
    }
}

export class Number extends FieldType {

    public initFormElement(form: JQuery<HTMLElement>): any {
        let input_name = `[name=${this.name}]`;

        form.find(input_name).closest(".form-group").find(".default-value-link").on("click", function (e) {
            const default_value = $(e.target).data("default-value");

            form.find(input_name).val(default_value);
        });
    }
}

export class Text extends FieldType {

    public initFormElement(form: JQuery<HTMLElement>): any {
        let input_name = `[name=${this.name}]`;

        form.find(input_name).closest(".form-group").find(".default-value-link").on("click", function (e) {
            const default_value = $(e.target).data("default-value");

            form.find(input_name).val(default_value);
        });
    }
}

export class Checkbox extends FieldType {

    public initFormElement(form: JQuery<HTMLElement>): any {}
}

export class Riskmatrix extends FieldType {

    public initFormElement(container: JQuery<HTMLElement>): any {
        let input_name = `[name=${this.name}]`;

        const riskMatrixManager = RiskMatrixManager.getInstance();

        container.find(input_name).each((index, element) => {
            riskMatrixManager.addInput($(element));
        });
    }

    public initFilter(container: JQuery<HTMLElement>) {
        let input_name = `[name=${this.name}]`;

        container.find(input_name).select2({
            width: '100%',
            dropdownAutoWidth: true,
            minimumResultsForSearch: -1,
            placeholder: this.placeholder,
            templateResult: this.formatOption,
            templateSelection: this.formatOption
        }).on("select2:close", function (e) {  
            container.find(input_name).valid(); 
        });
    }
}

export class LedRiskmatrix extends FieldType {

    public initFormElement(container: JQuery<HTMLElement>): any {
        let input_name = `[name=${this.name}]`;

        const riskMatrixManager = LedRiskMatrixManager.getInstance();

        container.find(input_name).each((index, element) => {
            riskMatrixManager.addInput($(element));
        });
    }

    public initFilter(container: JQuery<HTMLElement>) {
        let input_name = `[name=${this.name}]`;

        container.find(input_name).select2({
            width: '100%',
            dropdownAutoWidth: true,
            minimumResultsForSearch: -1,
            placeholder: this.placeholder,
            templateResult: this.formatOption,
            templateSelection: this.formatOption
        }).on("select2:close", function (e) {  
            container.find(input_name).valid(); 
        });
    }
}

export class Erc extends FieldType {
    private result = [
        [1, 1, 1, 1],
        [2, 4, 20, 100],
        [10, 21, 101, 500],
        [50, 102, 502, 2500]
    ];

    public initFormElement(container: JQuery<HTMLElement>): any {
        container.find(".erc-help-button").popover({
            title: "Help",
            content: `
                <b>How to answer question 1:</b><br>
                <ul>
                    <li>Think how the event could have escalated into an accident outcome (see examples to the right of the ERC matrix). Typically, the escalation could be due to actions by the people involved, the way the hazard interferes with the flight, and barrier behaviour
                    <li>Do not filter out improbable scenarios. Question 2 will take the (low) probability into account
                    <li>Among the scenarios with an accident outcome, pick the most credible one, and select the corresponding row in the matrix.
                </ul>
                <b>How to answer question 2:</b><br>
                    <ul>
                        <li>To assess the remaining safety margin, consider both the number and robustness of the remaining barriers between this event and the accident scenario identified in Question 1;
                        <li>Barriers, which already failed are ignored;
                        <li>Select the column of choice.
                    </ul>
                </p>
            `,
            html: true,
            placement: 'left',
            trigger: 'click'
        });

        container.find("[name=erc_1], [name=erc_2]").select2({
            width: '100%',
            dropdownAutoWidth: true,
            minimumResultsForSearch: -1,
            placeholder: this.placeholder
        });

        this.evaluateERC(container);
        container.find("[name=erc_1], [name=erc_2]").on("change", () => {
            this.evaluateERC(container);
        });
    }

    private evaluateERC(container: JQuery<HTMLElement>) {
        const erc_1 = container.find("[name=erc_1]").val() as string;
        const erc_2 = container.find("[name=erc_2]").val() as string;

        if(erc_1 === "\\" || erc_2 === "\\") {
            container.find(".erc-result").html(``);
            return;
        }

        const value = this.result[erc_1][erc_2];
        let color = "";
        
        if(value > 0 && value < 20)
            color = "success";
        else if (value >= 20 && value < 500)
            color = "warning";
        else if(value >= 500 && value <= 2500)
            color = "danger";
        
        container.find(".erc-result").html(`
            <b>ERC:</b> <span class="kt-badge kt-badge--unified-${color} kt-badge--inline kt-badge--pill kt-badge--rounded kt-badge--bold kt-badge--lg ml-3">${value}</span>
        `)
    }

    public prepare(formData: FormData, $form: JQuery<HTMLElement>|null = null) {
        const erc_1 = formData.get("erc_1");
        const erc_1_notes = formData.get("erc_1_notes");
        const erc_2 = formData.get("erc_2");
        const erc_2_notes = formData.get("erc_2_notes");

        formData.delete("erc_1");
        formData.delete("erc_1_notes");
        formData.delete("erc_2");
        formData.delete("erc_2_notes");

        const erc = JSON.stringify({
            erc1: {
                value: erc_1,
                notes: erc_1_notes
            },
            erc2: {
                value: erc_2,
                notes: erc_2_notes
            }
        });
        formData.append("erc", erc);

        return formData;
    }
}

export class Label extends FieldType {

    public initFormElement(container: JQuery<HTMLElement>): any {}
}

export class Percentage extends FieldType {

    public initFormElement(form: JQuery<HTMLElement>): any {
        let input_name = `[name=${this.name}]`;

        form.find(input_name).closest(".form-group").find(".default-value-link").on("click", function (e) {
            const default_value = $(e.target).data("default-value");

            form.find(input_name).val(default_value);
        });
    }
}

export class Table extends FieldType {
    container: JQuery<HTMLElement>|null = null;
    table: DataTables.Api|null = null;

    public initFormElement(container: JQuery<HTMLElement>): any {
        let input_name = `#${this.name}`;
        this.container = container;
        const add_entry_container = container.find(".table-add-column");

        const columns: any[] = [];
        const add_entry_fields: FieldType[] = [];
        const column_defs: DataTables.ColumnDefsSettings[] = [];

        this.columns.forEach((column, index) => {
            const field = ReportField.getFieldTypeInstance(
                column.element.field_type,
                column.element.name,
                column.element.has_other,
                column.element.required,
                column.element.multiple,
                column.element.placeholder,
                column.element.orientation,
                column.element.default_value,
                column.element.additional_options,
                column.element.additional_validation_rules,
                []
            );
                
            if(this.additional_options.add_new_entry == 1) {
                field.initFormElement(add_entry_container);
                add_entry_fields.push(field);
            }

            let column_obj: any = {data: column.element.name};
            if(column.type === "hidden")
                column_obj.visible = false;
            columns.push(column_obj);
            
            column_defs.push({
                targets: index,
                render: (data) => {
                    return data !== "" ? data : "<i class='kt-font-plain'>N/D</i>";
                }
            });
        });
        
        if(this.additional_options.add_new_entry == 1) {
            columns.push({data: "actions"});
            column_defs.push({
                targets: -1,
                render: () => {
                    return '<div class="text-right"><button type="button" class="btn btn-sm btn-icon delete-row"><i class="fas fa-trash"></i></button></div>'
                }
            });
        }

        this.table = container.find(input_name).DataTable({
            paging: false,
            info: false,
            searching: false,
            ordering: false,
            columns: columns,
            columnDefs: column_defs,
            drawCallback: () => {
                this.columns.forEach((column) => {
                    const field = ReportField.getFieldTypeInstance(
                        column.element.field_type,
                        column.element.name,
                        column.element.has_other,
                        column.element.required,
                        column.element.multiple,
                        column.element.placeholder,
                        column.element.orientation,
                        column.element.default_value,
                        column.element.additional_options,
                        column.element.additional_validation_rules,
                        []
                    );
                        
                    if(column.type === "input") {
                        field.initFormElement($(input_name));
                    }
                });
            }
        });
        
        container.on("click", ".delete-row", (e) => {
            const row = $(e.target).parents('tr');

            Swal.fire({
                icon: "question",
                title: "Do you really want to remove this row?",
                text: "Other data can be affected from this removal. Do it only if you are sure of what you are doing.",
                showCancelButton: true,
                focusConfirm: false,
                confirmButtonText: "Confirm",
                reverseButtons: true
            })
            .then((response) => {
                if(response.isConfirmed) {
                    this.table?.row(row).remove();
                    Utils.successSwal("Row removed from the table.", "Please, press the \"Save\" button to confirm this change.").then(() => {
                        this.table?.draw();
                    });
                }
            });
        });

        add_entry_container.find(".confirm-new-entry").on("click", () => {
            let is_table_form_satisfied = true;
            let data: any = {};
            
            add_entry_fields.forEach((input) => {
                if(input instanceof Menu){
                    data[input.name] = add_entry_container.find(`[name=${input.name}] option:selected`).text() as string;
                    data[input.name] = data[input.name] === "Insert your answer here..." ? "" : data[input.name];
                }
                else {
                    data[input.name] = add_entry_container.find(`[name=${input.name}]`).val() as string;
                }

                if(add_entry_container.find(`[name=${input.name}]`).data("column-required") === "column_required" && data[input.name] === "")
                    is_table_form_satisfied = false;
                
            });

            add_entry_fields.forEach((input) => {
                add_entry_container.find(`[name=${input.name}]`).val("");
                add_entry_container.find(`[name=${input.name}]`).attr("data-risk", "");
                add_entry_container.find(`[name=${input.name}]`).trigger("change");
                add_entry_container.find(`select`).val("");
                add_entry_container.find(`select`).trigger("change");
            });

            data["actions"] = null;

            if(is_table_form_satisfied){
                Utils.successSwal("Row added to the table.", "Please, press the \"Save\" button to confirm this change.").then(() => {
                    this.table?.row.add(data).draw();
                });
            }
            else{
                Swal.fire({
                    icon: "warning",
                    title: "Invalid data.",
                    text: "Please, fill all the required fields."
                });
            }
        });
    }

    public prepare(formData: FormData, $form: JQuery<HTMLElement>|null = null) {
        formData.delete(this.name);
        this.columns.forEach((column) => {
            formData.delete(column.element.name);
        })

        const data = this.table?.rows().data();

        data?.each((value, index) => {
            this.columns.forEach((column) => {
                let input_value: string = "";
                
                if(column.type === "input" && $form)
                    input_value = $form.find(`input[name=${column.element.name}]`).eq(index).val() as string;
                else
                    input_value = value[column.element.name];

                formData.append(`${this.name}[${index}-${column.element.name}]`, input_value);
            });
        });
        
        return formData;
    }

    public serialize(container: JQuery<HTMLElement>) {
        const data = this.table?.rows().data();
        let serializeChunks: string[] = [];

        data?.each((value, index) => {
            this.columns.forEach((column) => {
                let input_value: string = "";
                
                if(column.type === "input" && container)
                    input_value = container.find(`input[name=${column.element.name}]`).eq(index).val() as string;
                else
                    input_value = value[column.element.name];

                serializeChunks.push(`${this.name}[${index}-${column.element.name}]=${input_value}`);
            });
        })
        
        return serializeChunks.join("&");
    }
}

export const FieldTypes: any = {
    Menu,
    State,
    Email,
    Date,
    Time,
    File,
    Longtext,
    Number,
    Text,
    Riskmatrix,
    LedRiskmatrix,
    Label,
    Erc,
    Percentage,
    Table,
    Checkbox
}